import React from 'react';
import { Button } from '@/components/ui/button';
import { PenLine, Inbox, BarChart3 } from 'lucide-react';
import { muted } from './mbApi';
import { AutoMatchButton } from './AutoMatchDialog';

export const Shortcuts = ({ ibId, caps, mineCount, setView, onBrief, onChanged }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="mb-shortcuts">
    <span className={`text-xs ${muted} mr-1`}>Pintasan:</span>
    <Button size="sm" variant="outline" className="h-10 text-sm" disabled={!caps.brief} title={caps.brief ? '' : 'Untuk PIC Brief / manager'}
      onClick={onBrief} data-testid="mb-shortcut-brief">
      <PenLine size={15} className="mr-1.5" /> Buat Brief
    </Button>
    <Button size="sm" variant="outline" className="h-10 text-sm" onClick={() => setView('mine')} data-testid="mb-shortcut-mine">
      <Inbox size={15} className="mr-1.5" /> Buka Tugasan Saya ({mineCount})
    </Button>
    <Button size="sm" variant="outline" className="h-10 text-sm" onClick={() => setView('results')} data-testid="mb-shortcut-results">
      <BarChart3 size={15} className="mr-1.5" /> Lihat Hasil
    </Button>
    {caps.test && <AutoMatchButton ibId={ibId} onDone={onChanged} />}
  </div>
);
